import $ from 'jquery';
import PropTypes from 'prop-types';
import React from 'react';
import { HighchartReactWrapper } from '@bingads-webui-react/highchart-react-wrapper';
import { getStrengthScore } from './ad-strength-helper';

export function AdStrengthScore({
  isForVNext = false,
  label,
  strength,
}) {
  const score = getStrengthScore(strength);
  let options = {
    chart: {
      marginBottom: 15,
      marginTop: 0,
      plotBackgroundColor: null,
      plotBorderWidth: 0,
      plotShadow: false,
      type: 'pie',
      height: 110,
      width: 110,
    },
    colors: ['#4285f4', '#e8f0fe'],
    credits: {
      enabled: false,
    },
    plotOptions: {
      pie: {
        allowPointSelect: false,
        dataLabels: {
          enabled: false,
        },
        endAngle: 360,
        startAngle: 0,
        size: '100%',
      },
      series: {
        animation: false,
      },
    },
    series: [{
      type: 'pie',
      name: 'Ad Strength',
      data: [score, 100 - score],
      innerSize: '75%',
      showInLegend: false,
      states: {
        hover: {
          enabled: false,
        },
        inactive: {
          enabled: false,
        },
      },
    }],
    title: {
      text: label,
      align: 'center',
      verticalAlign: 'bottom',
      style: {
        fontSize: 14,
        fontWeight: 'bold',
      },
    },
    tooltip: {
      enabled: false,
    },
  };

  if (isForVNext) {
    options = $.extend(true, options, {
      chart: {
        height: 150,
        width: 150,
      },
      colors: ['#0078D4', '#C7E0F4'],
      series: [{
        innerSize: '80%',
      }],
      title: {
        y: 30,
      },
    });
  }

  return (
    <HighchartReactWrapper
      className="ad-strength-score"
      options={options}
    />
  );
}

AdStrengthScore.propTypes = {
  isForVNext: PropTypes.bool,
  label: PropTypes.string.isRequired,
  strength: PropTypes.string.isRequired,
};

AdStrengthScore.defaultProps = {
  isForVNext: false,
};
